import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@src/lib/ui/DropdownMenu";
import useIsFullAdmin from "@src/features/app/hooks/useIsFullAdmin";
import useActionPermissions from "@src/features/app/hooks/useActionPermissions";
import { Button } from "@src/lib/ui/Button";
import PlusIcon from "@src/lib/icons/18px/plus";
import Text from "@src/lib/ui/Text";
import InviteTraineeDialog from "@src/features/users/InviteTraineeDialog";
import NoPermissionsTooltipWrapper from "@src/lib/ui/NoPermissionsTooltipWrapper";
import InviteAdminOrManagerDialog from "@src/features/users/InviteAdminOrManagerDialog";

const InviteUsersDropdown: React.FC = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [qrDialogOpen, setQrDialogOpen] = useState(false);
  const [adminOrManagerDialogOpen, setAdminOrManagerDialogOpen] =
    useState(false);
  const { userActionPermissions } = useActionPermissions();
  const isFullAdmin = useIsFullAdmin();

  const handleAdminOrManagerDialogOpen = () => {
    setAdminOrManagerDialogOpen(true);
    setDropdownOpen(false);
  };

  const handleQRCodeDialogOpen = (event: React.MouseEvent) => {
    event.preventDefault();
    setQrDialogOpen(true);
    setDropdownOpen(false);
  };

  return (
    <>
      <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
        <DropdownMenuTrigger disabled={!userActionPermissions?.inviteOthers}>
          <NoPermissionsTooltipWrapper
            hasPermission={userActionPermissions?.inviteOthers}
          >
            <Button
              size="md"
              dataTestId="invite-users-button"
              disabled={!userActionPermissions?.inviteOthers}
            >
              <PlusIcon />
              Invite Users
            </Button>
          </NoPermissionsTooltipWrapper>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={handleQRCodeDialogOpen}>
            <Text variant="compact-description">Trainee</Text>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleAdminOrManagerDialogOpen}>
            <Text variant="compact-description">
              {isFullAdmin ? "Admin or Manager" : "Manager"}
            </Text>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <InviteTraineeDialog open={qrDialogOpen} onOpenChange={setQrDialogOpen} />
      <InviteAdminOrManagerDialog
        open={adminOrManagerDialogOpen}
        onOpenChange={setAdminOrManagerDialogOpen}
      />
    </>
  );
};

export default InviteUsersDropdown;
